import React from "react"

import { FaGithub, FaLinkedin, FaDribbbleSquare } from 'react-icons/fa';
import { MdEmail } from "react-icons/md";
import { SiCodewars } from 'react-icons/si';

const Contact = () => {
  return (
    <div>
      <a href="mailto:philanemsibi14@email.com" className="social_button"
      rel="noreferrer"
      title="Send me an Email"
      target="_blank">
        <MdEmail className="icon" />
      </a>
      <a
        href="https://www.linkedin.com/in/philane-msibi/"
        className="social_button"
        rel="noreferrer"
        title="Check LinkedIn Account"
        target="_blank"
      >
        <FaLinkedin className="icon" />
      </a>
      <a
        href="https://github.com/philane-Msibi-Ndlondlo"
        className="social_button"
        rel="noreferrer"
        title="Check GitHub Account"
        target="_blank"
      >
        <FaGithub className="icon" />
      </a>
      <a
        href="https://dribbble.com/Philane/shots"
        className="social_button"
        rel="noreferrer"
        title="Check Dribble Account"
        target="_blank"
      >
        <FaDribbbleSquare className="icon" />
      </a>
      <a
        href="https://www.codewars.com/users/philane-Msibi-Ndlondlo"
        className="social_button"
        rel="noreferrer"
        title="Check Codewars Profile"
        target="_blank"
      >
        <SiCodewars className="icon" />
      </a>
    </div>
  )
}

export default Contact
